import { useMemo } from "react"
import { useDisplayGlucoseValue } from "src/hooks/glucoseFormatting"
import type { Reading } from "src/types"

export function useReadingDelta(
  reading?: Reading,
  previousReading?: Reading,
): string | null {
  const displayGlucoseValue = useDisplayGlucoseValue()

  return useMemo(
    () => {
      // if there is no current or prior reading then render nothing
      if (!reading || !previousReading) {
        return null
      }

      // this only works because 0 mmol = 0 mgdl
      const recentValue = reading.glucose.mg_dl
      const secondValue = previousReading.glucose.mg_dl
      const diffValue = recentValue - secondValue
      const diffString = displayGlucoseValue(diffValue)

      if (diffValue >= 0) {
        return `+${diffString}`
      }

      return `${diffString}`
    },
    [
      displayGlucoseValue,
      reading,
      previousReading,
    ],
  )
}
